export default "__VITE_ASSET__Be$2I28k__"